/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People3Icon16Light } from './People3Icon16Light';
import { People3Icon16Regular } from './People3Icon16Regular';
import { People3Icon16Solid } from './People3Icon16Solid';
import { People3Icon20Light } from './People3Icon20Light';
import { People3Icon20Regular } from './People3Icon20Regular';
import { People3Icon20Solid } from './People3Icon20Solid';
import { People3Icon24Regular } from './People3Icon24Regular';
import { People3Icon24Solid } from './People3Icon24Solid';
import { People3Icon32Regular } from './People3Icon32Regular';
import { People3Icon64Regular } from './People3Icon64Regular';
var sizes = {
    16: {
        light: People3Icon16Light,
        regular: People3Icon16Regular,
        solid: People3Icon16Solid,
    },
    20: {
        light: People3Icon20Light,
        regular: People3Icon20Regular,
        solid: People3Icon20Solid,
    },
    24: {
        regular: People3Icon24Regular,
        solid: People3Icon24Solid,
    },
    32: {
        regular: People3Icon32Regular,
    },
    64: {
        regular: People3Icon64Regular,
    },
};
export var People3Icon = forwardRef('People3Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
